<script setup>
import LegalAddress from '@/Components/LegalAddress.vue';
import FooterMenu from '@/Components/FooterMenu.vue';
import CopyrightFooter from '@/Components/CopyrightFooter.vue';
import { usePlatform } from '../composables/usePlatform.js';
import ApplicationLogo from './ApplicationLogo.vue';
import { computed } from 'vue';
const { isPlatform } = usePlatform();
const url = computed(() => (isPlatform('PH').value ? 'https://www.pornhub.com' : 'https://www.fancentro.com'));
</script>
<template>
    <div class="flex min-h-screen flex-col items-center bg-surface-800 pt-8 sm:justify-center sm:pt-0">
        <header class="sticky top-0 z-50 flex h-14 w-full items-center bg-surface-800 lg:h-18 lg:px-8">
            <div class="mx-auto flex w-full max-w-6xl items-center justify-center">
                <application-logo :url="url" />
            </div>
        </header>
        <div class="flex w-full flex-1 items-center justify-center">
            <Card class="m-3 w-full max-w-md md:p-2">
                <template #header>
                    <slot name="header"></slot>
                </template>
                <template #content>
                    <slot />
                </template>
            </Card>
        </div>
        <div class="flex w-full justify-center p-8">
            <slot name="footer">
                <div class="w-full max-w-6xl space-y-2 lg:px-6">
                    <footer-menu :items="$page.props.menu.footer" />
                    <div>
                        <CopyrightFooter></CopyrightFooter>
                        <LegalAddress></LegalAddress>
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>
